import { AlertTriangleIcon, Loader2Icon } from 'lucide-react'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useGitbookSSO } from '@/api/gitbook-sso.hook'

import { Button } from '@/components/lemmala-design-system/button/button'

export const DocsSSOPage = () => {
  const [params] = useSearchParams()
  const location = params.get('location') ?? ''
  const { data, isError } = useGitbookSSO(location)

  useEffect(() => {
    if (data?.redirectUrl) {
      window.location.assign(data.redirectUrl)
    }
  }, [data])

  if (isError) {
    const repickUrl = `https://us.lema.ai/docs-login?repick=1${
      location ? `&location=${encodeURIComponent(location)}` : ''
    }`
    return (
      <div className='flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center'>
        <AlertTriangleIcon className='size-12' />
        <h2 className='text-main-foreground-primary text-heading-small'>
          Unable to authenticate for docs
        </h2>
        <p className='max-w-md text-main-foreground-secondary'>
          Your session may belong to a different Lema region. Try picking another region.
        </p>
        <Button variant='outline' onClick={() => window.location.assign(repickUrl)}>
          Choose a different region
        </Button>
      </div>
    )
  }

  return (
    <div className='flex min-h-screen flex-col items-center justify-center gap-4'>
      <Loader2Icon className='size-8 animate-spin' />
      <p className='text-main-foreground-secondary'>Redirecting to docs…</p>
    </div>
  )
}
